var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CCard',[_c('CCardHeader',[_vm._v(_vm._s(_vm.$t('dashBoard.cSysTodaySales.todaySales')))]),_c('CCardBody',[_c('CChartBarSimple',{attrs:{"background-color":"danger"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }